module.exports = __webpack_public_path__ + "static/media/aiDesignerHsbcTemplate3.cbe4faf0.jpg";